import * as React from 'react';

import { LocationViewModel } from 'models';

import { WhatsAroundListItem } from './list-item';

interface NearbyPOIsProps {
  nearbyPOIsList: LocationViewModel[];
}

export const NearbyPOIs: React.FunctionComponent<NearbyPOIsProps> = ({ nearbyPOIsList }) => {
  const poiListItems = nearbyPOIsList.map((location, index) => {
    if (!location) {
      return null;
    }
    const { accessibleCategory, category, distance, name } = location;
    if (!(name && distance)) {
      return null;
    }
    const iconId = `whats-around-location-category-${index}`;
    const liContent = `${name} - ${distance}`;
    const liKey = `location-${index}`;

    return (
      <WhatsAroundListItem
        accessibleCategory={accessibleCategory}
        category={category}
        iconId={iconId}
        id={liKey}
        key={liKey}
        liClassName="locations__list-item"
        liContent={liContent}
        displayIcons={false}
      />
    );
  });

  return (
    <ul className="uitk-type-list-300 locations__list no-bullet" data-stid="whats-around-popular-locations">
      {poiListItems}
    </ul>
  );
};
